// Add only verified PlantAdopting profile URLs. Empty entries remain unavailable.
export const SOCIAL_LINKS = { instagram: 'https://www.instagram.com/plantadopting/', facebook: '', linkedin: '', youtube: '' };
export function officialSocialUrl(value) {
  try { const url = new URL(value); return url.protocol === 'https:' ? url.href : null; }
  catch { return null; }
}
